<template>
  <button
    :disabled="!formValid"
    :name="fragment.uuid"
    :value="fragment.uuid"
    class="btn e2e-button"
    :class="fragment.image ? 'btn-link' : 'btn-primary'"
    @click.stop.prevent="onSubmit"
  >
    <fragment-image v-if="fragment.image" :fragment="fragment.image"/>
    <fragment-label v-if="fragment.label" :fragment="fragment.label"/>

    <span v-if="showDefaultIcon">
      <i v-if="showDefaultIcon" class="fa fa-paper-plane"></i>
      Absenden
    </span>
    
  </button>
</template>

<script>
import { formToJson } from "../layout-bom";
import { onRevalidateForms } from "../utils.js";

export default {
  name: "fragment-button",
  props: ["fragment"],
  data: function() {
    return {
      formValid: true
    };
  },
  computed: {
    showDefaultIcon() {
      return this.fragment.image === null && this.fragment.label.text === "";
    }
  },
  mounted() {
    const that = this;
    onRevalidateForms(function() {
      const { allAreValid } = formToJson(that.$el);
      that.formValid = allAreValid;
    });
  },
  methods: {
    async onSubmit() {
      const that = this;
      that.$nextTick(() => {
        let { form, allAreValid } = formToJson(that.$el);
        if (allAreValid) {
          that.$store.dispatch("sendForm", { form: form });
        }
      });
    }
  }
};
</script>
 

<style scoped>
</style>